module.exports = __webpack_public_path__ + "static/img/cmeetalk.b18822f3.svg";